module.exports = __webpack_public_path__ + "img/group-dark.887a8a98.png";